import RecipientInformation from '@/src/modules/build-a-card/inputs/RecipientInformation'
import { styled } from '@stitches/react'
import { useGiftQuantityContext } from '@/src/common/contexts/GiftQuantityContext'

const FormWrapper = styled('div', {
    marginBottom: 10,
})

const CollectionOfRecipientForms = () => {
    const { giftState } = useGiftQuantityContext()
    const { cardQuantity, listOfRecipients } = giftState
    const hasMoreThanOneRecipient = cardQuantity > 1

    const forms = listOfRecipients.map((recipient, index) => {
        return (
            <FormWrapper key={`recipient-${index}`}>
                <RecipientInformation
                    recipient={recipient}
                    recipientIndex={index}
                    hasMoreThanOneRecipient={hasMoreThanOneRecipient}
                />
            </FormWrapper>
        )
    })

    return <>{forms}</>
}

export default CollectionOfRecipientForms
